import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { SearchInputTxn, RadioContent, RadioWrap, Mainwrapper, DisplayFlex, TableContainer, FilterBtn, FilterBtnContainer, Trangle } from "./styles";
import { Radio, Divider, Collapse } from "antd";
import { RadioButton } from '../../../../CommonComponents/commonStyles';
import { forEach } from "lodash";
import {
  DesktopHeader,
  MobileHeader
} from "./../../Components/Fee&Expenses/styles";
import { DividerWrap, DisplayWrap, FeeHead, TranText } from './../../Components/Fee&Expenses/styles';
import TransactionDetailsFootnotes from './../../Components/TransactionDetailsFootnotes';
import ContributionsTable from "../ContributionsTable";
import ExchangeTable from './../../Components/ExchangeTable';
import OtherTransactionsTable from './../../Components/OtherTransactionsTable';
import GrantsTable from './../../Components/GrantsTable';
import AllTransactionTable from './../../Components/AllTransactionTable';
import formatter from './../../../../utils/formatter';
import filterIcon from './../../../../assets/icons/filter-filled-tool-symbol.svg'
import Preloader from "./../../../../CommonComponents/Preloader/Preloader";
import { getTitleYearsText, getParenthesis } from "./../../Pages/txnUitls"
import { milliToDate, initiateTracking, formatShares, recordError } from './../../../../utils/commonUtil';
import { CapsuleButton } from './../../../../CommonComponents/Commons/commonComponents';
import SearchIcon from "./../../../../assets/icons/search-icon.svg";
import { exportTxnData, filterDataPrint } from "../../Pages/actions";

const { Panel } = Collapse;

const RadioGroup = Radio.Group;

export class CommonTabContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      searchText: {
        contributions: "",
        exchanges: "",
        grants: "",
        otherTransactions: "",
        allTransactions: "",
      },
      contributionsData: [],
      exchangesData: [],
      grantsData: [],
      otherTransactionsData: [],
      allTransactionData: [],
      showFilter: (window.screen.width > 767) ? true : false,
    };
  }

  componentDidMount() {
    this.setState({
      allTransactionData: this.props.filterdata.allTransactionData,
      contributionsData: this.props.filterdata.contributions,
      exchangesData: this.props.filterdata.exchanges,
      grantsData: this.props.filterdata.grants,
      otherTransactionsData: this.props.filterdata.otherTransactions,
    })
  }

  componentWillReceiveProps(nextProps) {
    let searchData = "";
    switch (this.props.tabType) {
      case 'Contributions':
        searchData = this.state.searchText.contributions;
        break;
      case 'Exchanges':
        searchData = this.state.searchText.exchanges;
        break;
      case 'Grants':
        searchData = this.state.searchText.grants;
        break;
      case 'OtherTransactions':
        searchData = this.state.searchText.otherTransactions;
        break;
      case 'AllTransactions':
        searchData = this.state.searchText.allTransactions;
        break;
    }

    this.setState({
      allTransactionData: nextProps.filterdata.allTransactionData,
      contributionsData: nextProps.filterdata.contributions,
      exchangesData: nextProps.filterdata.exchanges,
      grantsData: nextProps.filterdata.grants,
      otherTransactionsData: nextProps.filterdata.otherTransactions,
    }, () => {
      this.searchHandler(searchData)
    })
  }

  handleShowMore = () => {
    try {
      this.setState({
        show: !this.state.show
      }, () => {
        // Analytic func will call only when Transactional Details will open
        if (this.state.show) {
          initiateTracking('showMore', this.props.pageTitle, 'Transactional Details', 'Show More');
        }
      });
    } catch (error) {
      recordError(error);
    }
  };

  compareData = (data, input, type) => {
    let isMatched = false;
    for (let key in data) {
      if (data[key]) {
        switch (key) {
          case 'amount':
          case 'pricePerUnit':
            let dollaeAmoult = formatter({
              value: data[key],
              fieldSuffix: 'Dollars',
            });
            if (dollaeAmoult.toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            }
            if (data[key].toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            }
            const isParenthesis = getParenthesis(data, type);
            if (isParenthesis) {
              if (`(${dollaeAmoult.toString()})`.toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
                isMatched = true;
              }
            }
            break;
          case 'saleDate':
          case 'receivedDate':
          case 'settlementDate':
          case 'tradeDate':
          case 'enteredDate':
          case 'dateRequested':
          case 'issueDate':
            let dateFormat = milliToDate(data[key]);
            if (dateFormat.toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            }
            break;
          case 'purpose':
            if (data[key].description.toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            }
            break;
          case 'noOfShares':
            if (data[key].toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            } else if (formatShares(data[key]).toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            }
            break;
          default:
            if (data[key].toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
              isMatched = true;
            }
        }
      }
    }
    return isMatched;
  }
 
  searchHandler = input => {
    let prevState = this.state;
    switch (this.props.tabType) {
      case 'Contributions':
        prevState.searchText.contributions = input;
        let newContributionsData = [];
        if (this.props.filterdata.contributions) {
          this.props.filterdata.contributions.map((data) => {
            let isContributionsMatched = this.compareData(data, input)
            if (isContributionsMatched) {
              newContributionsData.push(data);
            }
          })
          prevState.contributionsData = newContributionsData;
        }
        break;
      case 'Exchanges':
        prevState.searchText.exchanges = input;
        let newExchangesData = [];
        if (this.props.filterdata.exchanges) {
          this.props.filterdata.exchanges.map((data) => {
            let isExchangesMatched = this.compareData(data, input)
            for (let key in data) {
              if (data[key]) {
                if (data[key].toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
                  isExchangesMatched = true;
                }
                if (key === "fromInvestmentOption") {
                  data[key].map((from) => {
                    for (let fromkey in from) {
                      if (from[fromkey]) {
                        if (from[fromkey].toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
                          isExchangesMatched = true;
                        }
                        if (fromkey === 'value') {
                          let dollaeAmoult = formatter({
                            value: from[fromkey],
                            fieldSuffix: 'Dollars',
                          });
                          if (`($${from[fromkey].toString()})`.toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
                            isExchangesMatched = true;
                          }
                          if (`(${dollaeAmoult.toString()})`.toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
                            isExchangesMatched = true;
                          }
                        }
                      }
                    }
                  })
                }
                if (key === "toInvestmentOption") {
                  data[key].map((to) => {
                    for (let tokey in to) {
                      if (to[tokey]) {
                        if (to[tokey].toString().toLocaleLowerCase().replace(/\s/g, '').indexOf(input.toString().toLocaleLowerCase().replace(/\s/g, '')) !== -1) {
                          isExchangesMatched = true;
                        }
                      }
                    }
                  })
                }
              }
            }
            if (isExchangesMatched) {
              newExchangesData.push(data);
            }
          })
          prevState.exchangesData = newExchangesData;
        }
        break;
      case 'Grants':
        prevState.searchText.grants = input;
        let newGrantsData = [];
        if (this.props.filterdata.grants) {
          this.props.filterdata.grants.map((data) => {
            let isGrantsMatched = this.compareData(data, input, 'Grants')
            if (isGrantsMatched) {
              newGrantsData.push(data);
            }
          })
          prevState.grantsData = newGrantsData;
        }
        break;
      case 'OtherTransactions':
        prevState.searchText.otherTransactions = input;
        let newOtherTransactionsData = [];
        if (this.props.filterdata.otherTransactions) {
          this.props.filterdata.otherTransactions.map((data) => {
            let isOtherTransactionsMatched = this.compareData(data, input, 'OtherTransactions')
            if (isOtherTransactionsMatched) {
              newOtherTransactionsData.push(data);
            }
          })
          prevState.otherTransactionsData = newOtherTransactionsData;
        }
        break;
      case 'AllTransactions':
        prevState.searchText.allTransactions = input;
        let newAllTransactionData = [];
        if (this.props.filterdata.allTransactionData) {
          this.props.filterdata.allTransactionData.map((data) => {
            let isAllTransactionMatched = this.compareData(data, input)
            if (isAllTransactionMatched) {
              newAllTransactionData.push(data);
            }
          })
          prevState.allTransactionData = newAllTransactionData;
        }
        break;
    }
    this.setState(prevState)
  }

  transactionsCount = (type) => {
    if (this.props.data) {
      switch (type) {
        case 'Contributions':
          return (this.state.contributionsData) ? this.state.contributionsData.length : null;
        case 'Grants':
          return (this.state.grantsData) ? this.state.grantsData.length : null;
        case 'Exchanges':
          return (this.state.exchangesData) ? this.state.exchangesData.length : null;
        case 'OtherTransactions':
          return (this.state.otherTransactionsData) ? this.state.otherTransactionsData.length : null;
        case 'AllTransactions':
          //we need to count as a single transaction for "toExchange" and "fromExchange" in All transaction tab for Exchanges 
          if (this.state.allTransactionData.length > 0) {
            let exchangesCount = 0;
            this.state.allTransactionData.map((data) => {
              if (data.tabType === 'Exchange') {
                exchangesCount += 1;
              }
            })
            return (this.state.allTransactionData.length - exchangesCount / 2)
          } else {
            return 0;
          }
      }
    }
  }

  totalGrantCalc = (data) => {
    let total = 0;
    if (data.reversal) {
      total = data.amount ? data.amount : 0;
    } else {
      total = data.amount ? -data.amount : 0;
    }
    return Math.round((total + Number.EPSILON) * 100) / 100;
  }

  totalContributionCalc = (data) => {
    let total = 0;
    if (data.status === "Reversed") {
      total = data.amount ? -data.amount : 0;
    } else {
      total = data.amount ? data.amount : 0;
    }
    return Math.round((total + Number.EPSILON) * 100) / 100;
  }

  totalExchangesCalc = (data) => {
    let fromAmount = 0, toAmount = 0;
    if (data.fromInvestmentOption && data.fromInvestmentOption.length > 0) {
      data.fromInvestmentOption.map((fromInvestment) => {
        fromAmount += parseFloat(fromInvestment.value);
      })
    }
    if (data.toInvestmentOption && data.toInvestmentOption.length > 0) {
      data.toInvestmentOption.map((toInvestment) => {
        toAmount += parseFloat(toInvestment.value);
      })
    }
    return (toAmount.toFixed(2) - fromAmount.toFixed(2));
  }

  totalOtherTransactionsCalc = (data) => {
    let total = 0;
    // Based on the decrease keyword we need to subtract the amount from the total amount but from API some time we are getting a negative amount also so it was adding
    if (data.amount) {
      if (data.decrease) {
        total = data.amount > 0 ? -data.amount : data.amount;
      } else {
        total = data.amount > 0 ? data.amount : -data.amount;
      }
      return Math.round((total + Number.EPSILON) * 100) / 100;
    } else {
      return 0;
    }
  }

  totalAmount = (type) => {
    let total = 0;
    const self = this;
    if (this.props.data) {
      switch (type) {
        case 'Contributions':
          forEach(self.state.contributionsData, function (data) {
            total += self.totalContributionCalc(data);
          });
          break;
        case 'Grants':
          forEach(self.state.grantsData, function (data) {
            total += self.totalGrantCalc(data);
          });
          break;
        case 'Exchanges':
          forEach(self.state.exchangesData, function (data) {
            total += self.totalExchangesCalc(data);
          });
          break;
        case 'OtherTransactions':
          forEach(self.state.otherTransactionsData, function (data) {
            total += self.totalOtherTransactionsCalc(data);
          });
          break;
        case 'AllTransactions':
          forEach(self.state.allTransactionData, function (data) {
            if (data.tabType === 'Grant') {
              total += self.totalGrantCalc(data);
            } else if (data.tabType === 'Exchange') {
              total += self.totalExchangesCalc(data);
            } else if (data.tabType === 'Other Transaction') {
              total += self.totalOtherTransactionsCalc(data);
            } else if (data.reversal) {
              total = Math.round((total + Number.EPSILON) * 100) / 100;
              total -= data.amount ? data.amount : 0;
            } else {
              total = Math.round((total + Number.EPSILON) * 100) / 100;
              total += data.amount ? data.amount : 0;
            }
          });
          break;
      }
    }
    if (isNaN(total)) {
      total = 0
    }
    if (total === 0) {
      return "$0.00"
    } else if (total < 0) {
      let nAmount = formatter({
        value: total,
        fieldSuffix: 'Dollars',
      });
      return `(${nAmount})`
    } else {
      return formatter({
        value: total,
        fieldSuffix: 'Dollars',
      });
    }
  }
  showFilterFun = () => {
    this.setState({ showFilter: !this.state.showFilter })
  }

  clickOverlay = (e) => {
    this.setState({ showFilter: false })
  }

  exportTxnData = (modifiedExchangesData) => {
    this.props.exportTxnData(
      { tab: 'Exchanges', data: modifiedExchangesData },
    );
  }

  tabTableData = () => {
    let tabTransactionalData = this.props.tabTransactionalData;
    switch (this.props.tabType) {
      case 'Exchanges':
        if (tabTransactionalData.exchanges && tabTransactionalData.exchanges.loading) {
          return <Preloader />
        }
        
        this.props.filterDataPrint(
          { tab: 'Exchanges', data: this.state.exchangesData }
          );

        return (
         <ExchangeTable
            searchText={this.state.searchText.exchanges}
            exchangesData={this.state.exchangesData} 
            exportTxnData={this.exportTxnData}
          />
        );
      case 'OtherTransactions':
        this.props.exportTxnData(
          { tab: 'OtherTransactions', data: this.state.otherTransactionsData },
        );

        
        if (tabTransactionalData.otherTransactions && tabTransactionalData.otherTransactions.loading) {
          return <Preloader />
        }
        
        this.props.filterDataPrint(
          { tab: 'OtherTransactions', data: this.state.otherTransactionsData }
          );

        return (
          <OtherTransactionsTable
            searchText={this.state.searchText.otherTransactions}
            otherTransactionsData={this.state.otherTransactionsData} />
        );
      case 'Grants':
        this.props.exportTxnData(
          { tab: 'Grants', data: this.state.grantsData },
        );
        
        if (tabTransactionalData.grants && tabTransactionalData.grants.loading) {
          return <Preloader />
        }
        this.props.filterDataPrint(
          { tab: 'Grants', data: this.state.grantsData }
          );
        return (
          <GrantsTable
            searchText={this.state.searchText.grants}
            grantsData={this.state.grantsData} />
        );
      case 'Contributions':
        this.props.exportTxnData(
          { tab: 'Contributions', data: this.state.contributionsData }
        );
        
        if (tabTransactionalData.contributions && tabTransactionalData.contributions.loading) {
          return <Preloader />
        }

        this.props.filterDataPrint(
          { tab: 'Contributions', data: this.state.contributionsData }
          );

        return (
          <ContributionsTable
            searchText={this.state.searchText.contributions}
            contributionsData={this.state.contributionsData} />
        );
      default:
        this.props.exportTxnData(
          { tab: 'AllTransactions', data: this.state.allTransactionData },
        );
        
        if (tabTransactionalData.all && tabTransactionalData.all.loading) {
          return <Preloader />
        }

        this.props.filterDataPrint(
          { tab: 'AllTransactions', data: this.state.allTransactionData }
          );
        return (
          <AllTransactionTable
            searchText={this.state.searchText.allTransactions}
            allTransactionData={this.state.allTransactionData}
            />
        );
    }
  };

  getFootnotesType = () => {
    let footnotesType = '';
    switch (this.props.tabType) {
      case 'Grants':
        footnotesType = 'field_transaction_footnotes_gran';
        break;
      case 'Exchanges':
        footnotesType = 'field_transaction_footnotes_exch';
        break;
      case 'OtherTransactions':
        footnotesType = 'field_transaction_footnotes_othe';
        break;
      case 'AllTransactions':
        footnotesType = 'field_transaction_footnotes_all';
        break;
      default:
        footnotesType = 'field_transaction_footnotes_cont';
    }
    return footnotesType;
  }
  tabContent = () => {
    let tabContent = '';
    const { tabType } = this.props
    if (tabType === 'Grants' || tabType === 'AllTransactions') {
      tabContent = 'The table only includes completed transactions. Cancelled  and denied transactions will only display in their respective activity tables.'
    }
    else {
      tabContent = 'The table only includes completed transactions. Cancelled transactions will only display in their respective activity tables.'
    }
    return tabContent;
  }
  showFootnotes = () => {
    if (this.props.footnotes) {
      if (this.props.footnotes[0][this.getFootnotesType()]) {
        return (
          <>
            <FeeHead>{this.props.footnotes[0].field_transaction_summary_title}</FeeHead>
            {this.state.show ?
              <CapsuleButton id="btnShowLessTrans" text="Show Less" onClick={this.handleShowMore} iconType="arrowUp" />
              :
              <CapsuleButton id="btnShowMoreTrans" text="Show More" onClick={this.handleShowMore} iconType="arrowDown" />
            }
          </>
        )
      }
    }
  }

  render() {
    let yearsText = getTitleYearsText(this.props.selectedVal);

    return (
      <div className="pos-rev" data-test="transaction-common-tab-content">
        {
          (this.state.showFilter && window.screen.width < 767)
            ?
            <div id="backgroundOverlayTxn" onClick={(e) => this.clickOverlay(e)}></div>
            : null
        }
        <FilterBtnContainer>
          <FilterBtn id="filterBtnIcon" onClick={this.showFilterFun}>
            Filter
            <img src={filterIcon} alt="Filter" />
          </FilterBtn>
        </FilterBtnContainer>
          { 
          (this.state.showFilter)
            ?
            <Mainwrapper id="filterPopup">
              <Trangle></Trangle>
              <SearchInputTxn
                aria-label=" txt summary filter"
                placeholder="Search"
                width={window.screen.width > 767 ? "316px" : "100%"}
                height={'40px'}
                suffix={<img
                  src={SearchIcon}
                  alt="search_icon"
                />}
                onSearch={(input) => this.searchHandler(input)}
                onBlur={(input) => this.searchHandler(input.target.value)}
                id="txtsearchField"
                
              />
              <RadioWrap>
                <RadioGroup onChange={(e) => this.props.radioChange(e, this.props.tabType)} defaultValue={this.props.txnRadioValue[this.props.tabType]}>
                  <RadioButton id="rdEnteredDate" value={"enteredDate"}><RadioContent>Entered Date</RadioContent></RadioButton>
                  <RadioButton id="rdTradeDate" value={"tradeDate"}><RadioContent>Trade Date</RadioContent></RadioButton>
                </RadioGroup>
              </RadioWrap>
            </Mainwrapper>
            : null
        }

        <TableContainer>
          {
            (yearsText !== "")
              ?
              <>
                <DesktopHeader marginBottom="0">
                  <DisplayFlex>
                    <div>Showing {this.transactionsCount(this.props.tabType)} transactions of {yearsText}</div>
                    {
                      //As for bug 6215 comment 23  and OW-547 no need to show totalAmount in Exchanges Tabs
                      //As for bug OW-47 and OW-30
                      <div>Total transaction amount: {this.totalAmount(this.props.tabType)}</div>
                    }
                  </DisplayFlex>
                </DesktopHeader>
                <MobileHeader>
                  <Collapse onClick={this.handleShowMore}>
                    <Panel header={`Showing ${this.transactionsCount(this.props.tabType)} transactions`} key="1">
                      <div>
                        of {yearsText}<br />
                        {
                          //As for bug 6215 comment 23 and OW-547 no need to show totalAmount in Exchanges Tabs
                          //As for bug OW-47 and OW-30
                          `Total transaction amount: ${this.totalAmount(this.props.tabType)}`
                        }
                      </div>
                    </Panel>
                  </Collapse>
                </MobileHeader>
              </>
              :
              <>
                <DesktopHeader marginBottom="0">
                  <DisplayFlex>
                    <div>Showing {this.transactionsCount(this.props.tabType)} transactions from {this.props.filterMinDate} to {this.props.filterMaxDate}</div>
                    {
                      //As for bug 6215 comment 23  and OW-547 no need to show totalAmount in Exchanges Tabs
                      //As for bug OW-47 and OW-30
                      <div>Total transaction amount: {this.totalAmount(this.props.tabType)}</div>
                    }
                  </DisplayFlex>
                </DesktopHeader>
                <MobileHeader>
                  <Collapse>
                    <Panel header={`Showing ${this.transactionsCount(this.props.tabType)} transactions`} key="1">
                      <div>
                        From {this.props.filterMinDate} to {this.props.filterMaxDate}<br />
                        {
                          //As for bug 6215 comment 23 and OW-547 no need to show totalAmount in Exchanges Tabs
                          //As for bug OW-47 and OW-30
                          `Total transaction amount: ${this.totalAmount(this.props.tabType)}`
                        }
                      </div>
                    </Panel>
                  </Collapse>
                </MobileHeader>
              </>

          }

          {
            this.tabTableData()
          }

           <TranText>{this.tabContent()}</TranText>
          {
            (this.props.footnotes && this.props.footnotes[0][this.getFootnotesType()])
              ?
              <DividerWrap marginBottom="23px">
                <Divider />
              </DividerWrap>
              : null
          }
          <DisplayWrap marginBottom="14px">
            {
              this.showFootnotes()
            }
          </DisplayWrap>
        </TableContainer>
        {
           this.state.show ? <TransactionDetailsFootnotes footnotes={this.props.footnotes[0][this.getFootnotesType()]} /> : null
        }
      </div>
    );
  }
};

CommonTabContent.propTypes = {
  filterMaxDate: PropTypes.string,
  filterMinDate: PropTypes.string,
  pageTitle: PropTypes.string,
  tabType: PropTypes.string,
  radioValue: PropTypes.object,
  selectedVal: PropTypes.arrayOf(PropTypes.string),
  filterdata: PropTypes.object,
  footnotes: PropTypes.object,
  txnRadioValue: PropTypes.object,
  tabTransactionalData: PropTypes.object,
  radioChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => {
  return {
    exportTxnData: data => dispatch(exportTxnData(data)),
    filterDataPrint: (data) => dispatch(filterDataPrint(data)),
  };
};

const mapStateToProps = state => ({
  data: state.getIn(["transactionSummary", "transactionalDetails", "data"]),
  filterdata: state.getIn(["transactionSummary", "filterData", "data"]),
  footnotes: state.getIn(["transactionSummary", "feeContent", "data"]),
  txnRadioValue: state.getIn(["transactionSummary", "txnRadioValue"]),
  tabTransactionalData: state.getIn(["transactionSummary", "tabTransactionalData"])
});

export default connect(mapStateToProps, mapDispatchToProps)(CommonTabContent);